import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import modern from './modern.js'

export default contract({
  modern: array([
    modern
  ])
})
